/**
 * Terra Draw keeps its own helper features (selection handles, mid points, closing / snapping
 * points of an unfinished shape) in the same store as the user's shapes. They must never reach
 * drawnFeatures, counts, Export GeoJSON or Undo. Pure module.
 */
const HELPER_FLAGS = ['selectionPoint', 'midPoint', 'closingPoint', 'snappingPoint', 'coordinatePoint', 'currentlyDrawing'];

export function isHelperFeature(f) {
  const p = f?.properties;
  return !!p && HELPER_FLAGS.some((k) => p[k]);
}

/** Snapshot minus helper features. */
export function userFeatures(snapshot) {
  return (Array.isArray(snapshot) ? snapshot : []).filter((f) => !isHelperFeature(f));
}
